import styled from 'styled-components';
import { snakeCase } from 'lodash';
import { spacing } from '@comicrelief/component-library';

const Wrapper = styled.div`
  background: ${({ theme, bgColor }) => theme.color(snakeCase(bgColor))};
  padding: ${spacing('l')} ${spacing('md')};
  text-align: center;
`;

const ItemWrapper = styled.div`
  margin: 0 auto;
  padding: ${spacing('l')} 0;
  max-width: 900px;
  height: auto;
  text-align: center;
`;

const IFrame = styled.iframe`
  border:0;
`;

export { Wrapper, ItemWrapper, IFrame };
